import React from "react";

const DemoExamSection = ({ onDemoClick }) => {
  return (
    <section id="demo" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-slate-900 rounded-[3rem] p-8 md:p-16 overflow-hidden shadow-2xl">
          {/* Fondo Decorativo */}
          <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px]" />
          <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/4 w-96 h-96 bg-indigo-600/20 rounded-full blur-[100px]" />

          <div className="relative grid lg:grid-cols-2 gap-12 items-center">
            {/* Columna Texto */}
            <div className="text-left">
              <span className="inline-block px-4 py-1.5 bg-blue-500/10 text-blue-400 text-xs font-black uppercase tracking-[0.2em] rounded-full mb-6 border border-blue-500/20">
                Ponte a prueba hoy
              </span>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
                Simulador Real de <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
                  Examen de Corredor
                </span>
              </h2>
              <p className="text-slate-400 text-lg mb-10 max-w-lg leading-relaxed">
                Experimenta el formato del examen oficial de la Junta Técnica de
                Bienes Raíces. Sin registros ni tarjetas.
              </p>

              <div className="grid sm:grid-cols-2 gap-6 mb-10">
                {[
                  { label: "Preguntas Reales", icon: "⚖️" },
                  { label: "Cronómetro", icon: "⏱️" },
                  { label: "Nota Instantánea", icon: "📊" },
                  { label: "Feedback IA", icon: "🤖" },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <span className="text-xl">{item.icon}</span>
                    <h4 className="text-white font-bold text-sm">
                      {item.label}
                    </h4>
                  </div>
                ))}
              </div>

              {/* Botón Llamativo */}
              <button
                onClick={onDemoClick}
                className="group relative px-10 py-5 bg-white text-slate-900 text-xl font-black rounded-2xl transition-all duration-300 hover:scale-105 active:scale-95 shadow-xl flex items-center gap-4 border-2 border-transparent"
                style={{
                  background:
                    "linear-gradient(white, white) padding-box, linear-gradient(to right, #3b82f6, #818cf8) border-box",
                }}
              >
                <div className="bg-blue-600 text-white p-1.5 rounded-full group-hover:rotate-12 transition-transform">
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  </svg>
                </div>
                <span>Hacer examen de prueba</span>
                <span className="absolute -top-3 -right-3 px-3 py-1 bg-emerald-500 text-white text-[10px] font-black uppercase tracking-widest rounded-lg shadow-lg rotate-12 group-hover:rotate-0 transition-transform">
                  ¡GRATIS!
                </span>
              </button>
            </div>

            {/* Columna Mockup (Solo Desktop) */}
            <div className="relative hidden lg:block">
              <div className="bg-slate-800 rounded-2xl border border-slate-700 shadow-2xl p-2 transform rotate-2">
                <div className="bg-slate-900 rounded-t-xl p-4 border-b border-slate-700 flex justify-between">
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-red-500/20" />
                    <div className="w-3 h-3 rounded-full bg-green-500/20" />
                  </div>
                  <div className="text-blue-400 font-bold text-xs font-mono">
                    45:12
                  </div>
                </div>
                <div className="p-8 space-y-4">
                  <div className="h-3 w-3/4 bg-slate-700 rounded-full" />
                  <div className="h-3 w-1/2 bg-slate-700 rounded-full mb-8" />
                  {[1, 2, 3].map((o) => (
                    <div
                      key={o}
                      className={`h-10 w-full rounded-lg border ${
                        o === 2
                          ? "border-blue-500 bg-blue-500/10"
                          : "border-slate-700"
                      } flex items-center px-4 gap-3`}
                    >
                      <div
                        className={`w-3 h-3 rounded-full ${
                          o === 2 ? "bg-blue-500" : "bg-slate-700"
                        }`}
                      />
                      <div className="h-2 w-24 bg-slate-600 rounded-full" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoExamSection;
